var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4945 12.4961C17.4945 12.938 17.3189 13.3617 17.0065 13.6742C16.694 13.9867 16.2702 14.1622 15.8283 14.1622H5.83153L2.49927 17.4945V4.1654C2.49927 3.72351 2.67481 3.29973 2.98727 2.98727C3.29973 2.67481 3.72351 2.49927 4.1654 2.49927H15.8283C16.2702 2.49927 16.694 2.67481 17.0065 2.98727C17.3189 3.29973 17.4945 3.72351 17.4945 4.1654V12.4961Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon07);
export default __webpack_public_path__ + "static/media/icon07.8202222d38ac8c70268d9a2b4c26987e.svg";
export { ForwardRef as ReactComponent };